import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Progress, Text } from '@chakra-ui/react';
import { Loading } from '@/components';
import { useUI } from '@/store';
export const LoadingScreen = () => {
    const { state: { loading: { message, opacity, progress, show } } } = useUI();
    return show ? (_jsxs(Loading, Object.assign({ opacity: opacity, zIndex: 9999 }, { children: [progress && (_jsx(Progress, { bg: 'darkBrandBlue.10', isAnimated: true, minW: '260px', rounded: 'full', size: 'xs', value: progress })), message && (_jsx(Text, Object.assign({ fontSize: 'lg', textAlign: 'center' }, { children: message })))] }))) : null;
};
